<template>
  <div class="page-business-intelligence-dashboard">
    <template v-if="hasBIAccess">
      <BINavigation active="performance" :main-action="mainAction" />
      <div>
        <keep-alive :include="['PageBICompetition', 'PageBIEmitters']">
          <router-view />
        </keep-alive>
      </div>
    </template>
    <BlurredFeatureOverlay
      v-else
      :title="$t('upsell.bi.title')"
      :lede="$t('upsell.bi.lede')"
      :benefits="biBenefits"
      full-viewport
    >
      <div class="page-business-intelligence-dashboard__blur-content">
        <BISamplePreview />
      </div>
    </BlurredFeatureOverlay>
  </div>
</template>
<script>
import BINavigation from '@/components/page-business-intelligence/BINavigation.vue';
import BISamplePreview from '@/components/upsell/BISamplePreview';
import BlurredFeatureOverlay from '@/components/upsell/BlurredFeatureOverlay';
import { tenantHasBusinessIntelligenceAccess } from '@/util/module-access-util';

export default {
  name: 'PageBIDashboard',
  components: {
    BINavigation,
    BISamplePreview,
    BlurredFeatureOverlay,
  },
  data() {
    return {
      // The page's main action (PageMainAction), as the header's "+" on phones.
      mainAction: null,
    };
  },
  provide() {
    return {
      pageHeader: {
        setAction: (action) => {
          this.mainAction = action;
        },
        clearAction: (action) => {
          if (this.mainAction === action) this.mainAction = null;
        },
      },
    };
  },
  computed: {
    hasBIAccess() {
      return tenantHasBusinessIntelligenceAccess();
    },
    biBenefits() {
      return [this.$t('upsell.bi.benefits.1'), this.$t('upsell.bi.benefits.2'), this.$t('upsell.bi.benefits.3')];
    },
  },
  mounted() {
    if (!this.hasBIAccess && this.$track && this.$track.biUpsellView) {
      this.$track.biUpsellView();
    }
  },
};
</script>

<style lang="scss" scoped>
.page-business-intelligence-dashboard {
  &__blur-content {
    pointer-events: none;
    user-select: none;
  }
}
</style>
